import React from 'react';
import { Link } from 'react-router-dom';
import './made-with-ai.css';

const MadeWithAI: React.FC = () => {
  return (
    <div className="made-with-ai">
      <main>
        <header className="made-with-ai__hero">
          <h1 className="made-with-ai__title">MADE WITH AI</h1>
          <p className="made-with-ai__subtitle">transparency in the age of LLMs</p>
        </header>

        <section className="made-with-ai__section">
          <div className="made-with-ai__card">
            <span className="made-with-ai__icon" aria-hidden="true">🤖</span>
            <h2>AI-Generated Code</h2>
            <p>
              The code for this website was written using large language models (LLMs).
              We used a combination of AI coding assistants including:
            </p>
            <ul className="made-with-ai__tools">
              <li><strong>Claude Code</strong> — Anthropic's CLI coding assistant</li>
              <li><strong>Cursor</strong> — AI-powered code editor</li>
              <li><strong>ChatGPT</strong> — OpenAI's conversational AI</li>
            </ul>
          </div>

          <div className="made-with-ai__card">
            <span className="made-with-ai__icon" aria-hidden="true">👨‍💻</span>
            <h2>Human Oversight</h2>
            <p>
              While AI wrote the code, a human was in control at all points during the
              development of this website. Every piece of generated code was:
            </p>
            <ul className="made-with-ai__checks">
              <li>Reviewed for correctness and security</li>
              <li>Tested to ensure it works as intended</li>
              <li>Approved before being merged into the codebase</li>
            </ul>
          </div>

          <div className="made-with-ai__card">
            <span className="made-with-ai__icon" aria-hidden="true">🎯</span>
            <h2>Why We're Sharing This</h2>
            <p>
              We believe in transparency about how software is built. AI tools are
              becoming an important part of software development, and we think it's
              right to be upfront about our use of them.
            </p>
            <p>
              This doesn't make the software any less carefully crafted — it just
              means we had some very capable assistants helping us build it.
            </p>
          </div>
        </section>

        <div className="made-with-ai__back">
          <Link to="/" className="made-with-ai__button">
            Back to Home
          </Link>
        </div>
      </main>

      <footer className="made-with-ai__footer">
        <div className="made-with-ai__footer-content">
          <div className="made-with-ai__footer-copyright">
            © {new Date().getFullYear()} Adrian Lansdown.
          </div>
        </div>
      </footer>
    </div>
  );
};

export default MadeWithAI;
